import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'reason',
      type: 'input',
      label: '原因',
      placeholder: '请输入原因',
      rules: { required: true, message: '原因是必传的', trigger: 'blur' }
    },
    {
      field: 'flow',
      type: 'select',
      label: '流向',
      placeholder: '请选择流向',
      options: [
        { title: '减积分', value: '0' },
        { title: '加积分', value: '1' }
      ],
      rules: { required: true, message: '流向是必选的', trigger: 'blur' }
    },
    {
      field: 'point',
      type: 'input',
      label: '积分数量',
      placeholder: '请输入积分数量',
      rules: { required: true, message: '积分数量是必传的', trigger: 'blur' }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
